<template v-once>
  <div>
    <div class="email-lists">
      <span class="share-email" v-for="(email, index) in shareEmails" :key="index">
        {{ email }}
        <i :class="'fas fa-times delete-' + index" @click="deleteEmail(email)"></i>
      </span>
    </div>

    <div class="email-input-area">
      <div class="input-emails-lists" id="input-emails-lists">
        <span class="share-email" :id="'scroll-'+ email" v-for="(email, index) in inputEmailShares" :key="index">
          {{ email }}
          <i :class="'fas fa-times delete-' + index" @click="removeInputEmail(email)"></i>
        </span>
      </div>

      <input
        autocomplete="off"
        v-model="emailAddress"
        v-on:keyup="getUserNames"
        id="emails_shares"
        placeholder="Add People"
        data-testid="share_email_inputs"
        class="email-input"
      />

      <div v-show="(usersList.length > 0)" class="dropdown-list">
        <div v-for="user in usersList" :key="user.email" @click="selectEmail(user.email)" class="dropdown-item">
          {{ user.email }}
        </div>
      </div>
    </div>
    <button data-testid="share_email_submit" @click="submitEmails()" href="#" class="cloudapp-btn blue mt-1">
      Share Link
    </button>
  </div>
</template>

<style scoped lang="scss">
@import '../../../../packs/application.scss';
  .email-lists {
    .share-email {
      padding: 0.375rem 0.5rem;
      border-radius: 13px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.28);
      font-size: 0.75rem;
      color: $bright-blue;
      margin-right: 1rem;
      margin-bottom: 0.5rem;
      display: inline-block;

      .fas {
        border-left: solid 1px $pale-gray-two;
        padding-left: 0.4rem;
        color: $dark-gray;
        cursor: pointer;
      }
    }
  }
  .email-input-area {
    background: $pale-gray;
    position: relative;

    .share-email {
      background-color: white;
      padding: 0.375rem 0.5rem;
      border-radius: 13px;
      font-size: 0.75rem;
      color: $almost-black;
      margin-left: 0.5rem;
      margin-top: 0.25rem;
      margin-bottom: 0.25rem;
      display: inline-block;
      border: $warm-gray 1px solid;
    }

    .dropdown-list {
      position: absolute;
      background: white;
      width: 100%;
      box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12);
      font-size: 0.8rem;

      .dropdown-item {
        padding: 0.7rem;
        color: $almost-black;
        cursor: pointer;
      }
    }
  }
  .email-input {
    padding: 0.5rem 2.188rem 0.5rem 0.5rem;
    font-size: 0.75rem;
    width: 100%;
    background: $pale-gray;
    border: none;
    border-bottom: 1px $almost-black solid;
    border-radius: 0;
  }

  .email-input:focus {
    padding: 0.5rem 2.188rem 0.5rem 0.5rem;
    font-size: 0.75rem;
    width: 100%;
    background: $pale-gray;
    outline: 0 none;
    border: none;
    border-bottom: 2px $bright-blue solid;
    border-radius: 0;
    box-shadow: none;
  }

  .cloudapp-btn {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: bold;
  }

</style>

<script>
import api from '../../../api';
import flash from '../../../flash';
export default {
  props: {
    id: String,
    emails: String
  },
  data: function() {
    return {
      emailAddress: "",
      usersList: [],
      shareEmails: this.emails ? JSON.parse(this.emails) : [],
      changedEmails: this.emails ? JSON.parse(this.emails) : [],
      inputEmailShares: []
    }
  },
  methods: {
    selectEmail: function(email) {
      if (this.inputEmailShares.indexOf(email) == -1 && this.inputEmailShares.length < 20) {
        this.inputEmailShares.push(email);
      }
      this.emailAddress = "";
      this.usersList = [];
    },
    getUserNames: function(e) {
      let self = this;
      if (e.keyCode == 188) {
        this.emailAddress = this.emailAddress.substring(0, this.emailAddress.length - 1);
        if (this.inputEmailShares.indexOf(this.emailAddress) == -1 && this.inputEmailShares.length < 20) {
          this.inputEmailShares.push(this.emailAddress);
        }
        this.emailAddress = "";
      }
      if (this.emailAddress.length < 2) {
        return;
      }

      this.$store.dispatch('searchUsers', { params: { q: this.emailAddress } })
      .then(function (response) {
        let returnValue = [];
        for (const user of response["data"]["data"]["results"]["attributes"]["users"]) {
          returnValue.push(user);
        }
        self.usersList = returnValue;
      });
    },
    removeInputEmail: function(email) {
      let index = this.inputEmailShares.indexOf(email);
      if (index !== -1) {
        this.inputEmailShares.splice(index, 1);
      }
    },
    submitEmails: function() {
      if (this.emailAddress != "") {
        this.inputEmailShares.push(this.emailAddress);
      }
      if (this.inputEmailShares.length > 0) {
        this.changedEmails = [...this.shareEmails, ...this.inputEmailShares];
        this.updateEmailShares();
      } else {
        this.inputEmailShares = [];
        this.emailAddress = "";
      }
    },
    deleteEmail: function(email) {
      let index = this.changedEmails.indexOf(email);
      if (index !== -1) {
        this.changedEmails.splice(index, 1);
      }
      this.updateEmailShares();
    },
    updateEmailShares: function() {
      const url = `/api/v4/items/${this.id}`;
      let self = this;
      api.patch(url,
          { "email_shares" : this.changedEmails, "email_shares_changed": true }
        )
        .then(res => {
          self.shareEmails = self.changedEmails;
          self.inputEmailShares = [];
          self.emailAddress = "";
          if (res.data && res.data.message) {
            flash.success(res.data.message)
          }
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            self.emailAddress = "";
            flash.error(err.response.data.message)
          }
        });
    }
  }
}
</script>
